import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Clock, Envelope, Telephone } from "react-bootstrap-icons";
import PageHero from "../../components/public/PageHero";
import Seo from "../../components/public/Seo";
import { CONTACT } from "../../components/landing/data/landingData";
import { FAQS } from "../../components/customer/help/CustomerHelpSupport";

/** /help - public Help & Support: the platform FAQs and ways to reach the team. */
const HelpSupport = () => {
  const [open, setOpen] = useState(FAQS[0]?.id);

  return (
    <>
      <Seo
        title="Help & Support | All Home Desire"
        description="Answers to common questions and ways to contact the All Home Desire support team."
        path="/help"
      />
      <PageHero title="Help & Support" subtitle="Quick answers, and a team that is happy to help." crumbs={[{ label: "Help & Support" }]} />

      <section className="lp-section">
        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-lg-7">
              <h2 className="lp-heading__title mb-4">Frequently asked questions</h2>
              <ul className="list-unstyled d-grid gap-3 mb-0">
                {FAQS.map((faq) => {
                  const isOpen = open === faq.id;
                  return (
                    <li key={faq.id} className="lp-card">
                      <h3 className="m-0">
                        <button
                          type="button"
                          className="lp-faq__q"
                          aria-expanded={isOpen}
                          aria-controls={`help-faq-${faq.id}`}
                          onClick={() => setOpen(isOpen ? null : faq.id)}
                        >
                          <span>{faq.question}</span>
                          <ChevronDown aria-hidden="true" className={isOpen ? "is-open" : ""} />
                        </button>
                      </h3>
                      {isOpen && <p id={`help-faq-${faq.id}`} className="lp-muted px-4 pb-4 mb-0">{faq.answer}</p>}
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="col-12 col-lg-5">
              <div className="lp-card p-4">
                <h2 className="lp-card__title">Still need help?</h2>
                <p className="lp-muted">Reach the support team directly.</p>
                <ul className="list-unstyled d-grid gap-3 mb-4">
                  <li className="d-flex gap-3"><Telephone aria-hidden="true" /> <a className="lp-link" href={CONTACT.phoneHref}>{CONTACT.phone}</a></li>
                  <li className="d-flex gap-3"><Envelope aria-hidden="true" /> <a className="lp-link" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
                  <li className="d-flex gap-3"><Clock aria-hidden="true" /> <span className="lp-muted">Mon - Sat, 9:00 AM - 7:00 PM IST</span></li>
                </ul>
                <Link to="/contactus" className="lp-btn lp-btn--primary w-100">Send us a message</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HelpSupport;
